export const siteSettings = {
  name: "EQX Finance",
  link: "https://eqxfinance.live",
  email: "support@eqxfinance.live",
  appLink: "https://app.eqxfinance.live/dashboard",
};
